import { useNavigate } from 'react-router';
import { useSession } from '../lib/session.js';

interface SessionBarProps {
  /**
   * StaffLayout passes false — the staff header has its own icon-styled sign
   * out button (StaffQuickActions.tsx, next to the gear icon) and renders
   * this component only for the "signed in as…" text. The portal keeps the
   * default (true): no equivalent icon cluster exists there yet.
   */
  showSignOutButton?: boolean;
}

/** "Signed in as…" plus sign-out. Rendered in both shells' headers. */
export function SessionBar({ showSignOutButton = true }: SessionBarProps) {
  const { state, signOut } = useSession();
  const navigate = useNavigate();

  if (state.status !== 'signed-in') return null;

  const { actor } = state.me;
  const role = actor.staffRole ? `${actor.actorType} · ${actor.staffRole}` : actor.actorType;

  async function onSignOut() {
    await signOut();
    const destination =
      actor.actorType === 'STAFF'
        ? '/staff/login'
        : actor.actorType === 'APPLICANT'
          ? '/apply'
          : '/login';
    void navigate(destination, { replace: true });
  }

  return (
    <>
      <span className="shell__spacer" />
      <span className="shell__who">
        {actor.email} <span className="pill">{role}</span>
      </span>
      {showSignOutButton ? (
        <button className="button button--quiet" type="button" onClick={() => void onSignOut()}>
          Sign out
        </button>
      ) : null}
    </>
  );
}
